export const categories = [
  { slug: 'wanfa-gonglue', name: '玩法攻略', description: '全面解析人渣游戏的操作机制与生存技巧', icon: 'ri-gamepad-line' },
  { slug: 'juqing-jiexi', name: '剧情解析', description: '深度剖析人渣游戏的叙事结构与隐藏线索', icon: 'ri-book-open-line' },
  { slug: 'daode-zhengyi', name: '道德争议', description: '探讨人渣游戏引发的伦理讨论与社会反响', icon: 'ri-scales-3-line' },
  { slug: 'wanjia-pingjia', name: '玩家评价', description: '汇集全球玩家对人渣游戏的真实体验与评分', icon: 'ri-chat-quote-line' },
  { slug: 'youxi-tuijian', name: '游戏推荐', description: '精选类似风格的暗黑系与成人向游戏推荐', icon: 'ri-thumb-up-line' },
];

export const categoryMap: Record<string, string> = {
  'wanfa-gonglue': '玩法攻略',
  'juqing-jiexi': '剧情解析',
  'daode-zhengyi': '道德争议',
  'wanjia-pingjia': '玩家评价',
  'youxi-tuijian': '游戏推荐',
};